type InlineTextProps = {
  value: string;
};
const InlineText = ({ value }: InlineTextProps) => {
  return (
    <div className="inline-block rounded px-4 py-1.5 my-1 text-gray-900 text-sm bg-gray-50 border border-gray-400 font-mono break-all">
      {value}
    </div>
  );
};

export default InlineText;
